import theme from "@shared/utils/themeColors";
import React from "react";

interface TextareaControlProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string | null;
  required?: boolean;
  className?: string;
  rows?: number;
  minHeight?: string;
}

const TextareaControl: React.FC<TextareaControlProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder = "",
  disabled = false,
  error = null,
  required = false,
  className = "",
  rows = 4,
  minHeight = "100px",
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={`block text-sm font-medium ${theme.text.secondary} mb-1`}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        className={`w-full form-input min-h-[${minHeight}] ${
          error ? "border-red-500" : ""
        }`}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
      />
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default TextareaControl;
